import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "relative mb-4 aspect-[373/238] w-full rounded-2xl overflow-hidden" }
const _hoisted_3 = ["data-src", "alt"]
const _hoisted_4 = { class: "flex flex-col justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "uppercase font-semibold text-purple-500 text-sm mb-1" }, "Nieuws", -1 /* HOISTED */)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-start gap-4 flex-wrap lg:items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "btn btn-purple-500" }, "Lees meer")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: `/blog/${$props.blogpost.slug}`,
    class: "group flex w-full flex-col"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        "data-src": $props.blogpost.featured_image_url,
        class: "absolute lazyload inset-0 h-full w-full object-cover object-center !transition-all duration-300 group-hover:scale-110",
        alt: $props.blogpost.title.rendered
      }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("p", {
        class: "uppercase font-semibold dark:text-white text-xl mb-4 md:text-2xl",
        innerHTML: $props.blogpost.title.rendered
      }, null, 8 /* PROPS */, _hoisted_6),
      _hoisted_7
    ])
  ], 8 /* PROPS */, _hoisted_1))
}